import { combineReducers } from "redux";
import { authReducer, mentorReducer, tagsReducer, scenariosReducer, pricingPlanReducer, profileReducer, FeedBackReducer, sessionReducer, industryReducer, recommendationReducer, quotesReducer, studentResourcesReducer, aiCompanionsReducer, strengthsReducer, careersReducer, actionPlanReducer, promptReducer } from "./reducers";


const rootReducer = combineReducers({
  authReducer,
  mentorReducer,
  pricingPlanReducer,
  tagsReducer,
  scenariosReducer,
  profileReducer,
  FeedBackReducer,
  sessionReducer,
  industryReducer,
  recommendationReducer,
  quotesReducer,
  studentResourcesReducer,
  aiCompanionsReducer,
  strengthsReducer,
  careersReducer,
  actionPlanReducer,
  promptReducer,
});

export default rootReducer;
